import React from 'react';

const HeroCanvasLoader = () => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="flex flex-col items-center">
        <div
          className="w-16 h-16 border-4 border-dashed rounded-full
                animate-spin border-blue-500 mb-4"
        ></div>
        <p
          className="text-base font-black bg-gradient-to-r
                    from-cyan-500 to-blue-600 bg-clip-text text-transparent"
        >
          Loading 3D Assets...
        </p>
      </div>
    </div>
  );
};

export default HeroCanvasLoader;
